import Slider, { Handle } from "rc-slider"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { NpsScreen } from "../../screen/NpsScreen"
import Send from "../../core/communication"

import EmojiOne from "../../assets/Emoticons/1.png"
import EmojiTwo from "../../assets/Emoticons/2.png"
import EmojiThree from "../../assets/Emoticons/3.png"
import EmojiFor from "../../assets/Emoticons/4.png"
import EmojiFive from "../../assets/Emoticons/5.png"
import EmojiSix from "../../assets/Emoticons/6.png"
import EmojiSeven from "../../assets/Emoticons/7.png"
import EmojiEight from "../../assets/Emoticons/8.png"
import EmojiNine from "../../assets/Emoticons/9.png"
import EmojiTen from "../../assets/Emoticons/10.png"

import "rc-slider/assets/index.css"

const formatEmoji = (value) => {
  switch (value) {
    case 1:
      return EmojiOne
    case 2:
      return EmojiTwo
    case 3:
      return EmojiThree
    case 4:
      return EmojiFor
    case 5:
      return EmojiFive
    case 6:
      return EmojiSix
    case 7:
      return EmojiSeven
    case 8:
      return EmojiEight
    case 9:
      return EmojiNine
    case 10:
      return EmojiTen
    default:
      return ""
  }
}

const marks = {
  1: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "1",
  },
  2: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "2",
  },
  3: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "3",
  },
  4: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "4",
  },
  5: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "5",
  },
  6: {
    style: {
      fontSize: 16,
      marginTop: -55,
    },
    label: "6",
  },
  7: {
    style: {
      fontSize: 16,
      marginTop: -55,
    },
    label: "7",
  },
  8: {
    style: {
      fontSize: 16,
      marginTop: -55,
    },
    label: "8",
  },
  9: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "9",
  },
  10: {
    style: {
      marginTop: -55,
      fontSize: 16,
    },
    label: "10",
  },
}

function NpsContainer() {
  const [searchParams] = useSearchParams()
  const [evaluation, setEvaluation] = useState(10)
  const [saving, setSaving] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [message, setMessage] = useState("")

  const idUser = searchParams.get("idUser")
  const idProject = searchParams.get("idProject")
  const description = searchParams.get("description")

  const handle = (props) => {
    const { value, ...restProps } = props
    setEvaluation(value)
    return (
      <Handle
        value={value}
        {...restProps}
        style={{
          height: 50,
          width: 50,
          borderWidth: 0,
          backgroundColor: "transparent",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}>
        <img src={formatEmoji(value)} width={60} height={60} />
      </Handle>
    )
  }

  const onSave = async () => {
    setSaving(true)
    try {
      const response = await Send.post(
        "/nps/training",
        { idUser, idProject, description, evaluation },
        false,
      )

      if (response.status === "ERROR" || response.error) {
        console.log(`Erro ao salvar: ${response.message}`)
        setError(true)
        setMessage("Feche essa tela e tente finalizar novamente.")
        return
      }

      setSuccess(true)
      setMessage("Cadastro efetuado com sucesso.")
    } catch (e) {
      setError(true)
      setMessage("Ocorreu um erro, tente novamente mais tarde!")
    }
  }

  return (
    <NpsScreen
      formatEmoji={(value) => formatEmoji(value)}
      marks={marks}
      saving={saving}
      setSuccess={setSuccess}
      evaluation={evaluation}
      creationState={{ error, success, message }}
      handle={(props) => handle(props)}
      onSave={() => onSave()}
      Slider={Slider}
      idUser={idUser}
      idProject={idProject}
      description={description}
      closeCreationModal={() => setError(false)}
    />
  )
}

export default NpsContainer
